import './Env_modal.scss'
import React ,{useEffect, useState} from 'react'
import functions from '../../functions/functions'
import Cookies from 'universal-cookie';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import socket from '../../socket/socket';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import { captureException } from '@sentry/browser';
import Button from '../Button/Button';
import Moment, { now } from 'moment'
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import linkIcon from '../../images/linkIcon.svg';
import deleteIcon from '../../images/deleteIcon.svg';
import Modal from'../Modal/Modal'
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Tooltip from '@mui/material/Tooltip';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import BackendSecrets from '../BackendSecrets/BackendSecrets';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
export default function Env_modal(props) {

  const [open, setOpen] = React.useState(false);
  const[open_unshare_modal,set_open_unshare_modal] = useState(false);
  const [open_lock_modal,set_open_lock_modal] = useState(false);
  const [ open_update_secrets , set_open_update_secrets] = useState(false)
  const [open_unlock_modal,set_open_unlock_modal] = useState(false);
  const [reason,set_reason]=useState("")
  const [lock,set_lock] = useState(false)
  const [lock_user,set_lock_user]  = useState("")
  const [change_backend,set_change_backend] = useState();
  const [change_frontend,set_change_frontend] = useState(false);
  const [backend_branch,set_backend_branch] = useState(props.env.backend_branch)
  const [frontend_branch,set_frontend_branch] = useState(props.env.frontend_branch)
  const [unshare_users,set_unshare_users]= useState(null)
  const [share_users,set_share_users] = useState(null)
  const [update_frontend,set_update_frontend] = useState(false);
  const[update_backend, set_update_backend] = useState(false);
  const[branch_selected_frontend,set_branch_selected_frontend]=useState("workiz.com");
  const[create_frontend,set_create_frontend]=useState(false)
  const[branch_selected_backend,set_branch_selected_backend]=useState("workiz.com");
  const [change_backend_open,set_change_backend_open] = useState(false)
  const [change_frontend_open,set_change_frontend_open] = useState(false)
  const [secrets , set_secrets] = useState([])
  const [muted,set_muted] = useState(false)
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    set_open_unshare_modal(false)
    set_open_lock_modal(false)
  };

  const [to_shared_users, set_to_shared_users] = useState([])
  const[env_users,set_env_users] = useState(props.env.users)
  const [autocomplete_values,set_autocomplete_values] = useState([])
  useEffect(async ()=>{
    socket.on('env_deleted', function(login) {
      if(cookies.get("login")==login){
        set_lock(false)
        const index = props.prev_envs.findIndex((element)=>element.env_name==props.env.env_name)
        let array = props.prev_envs
        array.splice(index,1)
        props.set_prev_envs(array)
      }
    });
  
    socket.on('update_frontend', function(inputs) {
      if(cookies.get("login")==inputs[0]){
        set_lock(false)
        set_update_frontend(false)
        set_create_frontend(false)
        const index = props.prev_envs.findIndex((element)=>element.env_name==props.env.env_name)
        let array = props.prev_envs
        array[index]["frontend_last_update"]=new Date()
        array[index]["frontend_branch"]=inputs[2][2]
        if(inputs[2][2]){
          array[index]["frontend_branch"]=inputs[2][2]
          set_frontend_branch(inputs[2][2])
        }
        props.set_prev_envs(array)
        props.setEnv(array[index])
      }
    });
  
    socket.on('update_front.sh', function(inputs) {
      if(cookies.get("login")==inputs[0]){
        set_lock(false)
        set_update_frontend(false)
      }
    });
  
    socket.on('update_backend', function(inputs) {
      if(cookies.get("login")==inputs[0]){
        set_lock(false)
        set_update_backend(false)
        set_change_backend(false)
        const index = props.prev_envs.findIndex((element)=>element.env_name==props.env.env_name)
        let array = props.prev_envs
        array[index]["backend_last_update"]=new Date()
        if(inputs[2][2]){
          array[index]["backend_branch"]=inputs[2][2]
          set_backend_branch(inputs[2][2])
        }
        props.set_prev_envs(array)
        props.setEnv(array[index])
      }
    });
    socket.on('update_backend.sh', function(inputs) {
      if(cookies.get("login")==inputs[0]){
        set_lock(false)
        set_update_backend(false)
      }
    });
  
    socket.on('add_front', function(inputs) {
      if(cookies.get("login")==inputs[0]){
        set_lock(false)
        set_create_frontend(false)
        const index = props.prev_envs.findIndex((element)=>element.env_name==props.env.env_name)
        let array = props.prev_envs
        array[index]["frontend_last_update"]=new Date()
        if(inputs[2][1])
          array[index]["frontend_branch"]=inputs[2][1]
        array[index]["add_front"]=true
        props.setEnv(array[index])
        props.set_prev_envs(array)
      }
    });
  
    socket.on('add_front.sh', function(inputs) {
      if(cookies.get("login")==inputs[0]){
        set_lock(false)
        set_create_frontend(false)
      }
    });

    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "code": cookies.get("code"),
      "env_name" : props.env.env_name ,
    })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_env_backend_secrets/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
        set_secrets(data)
      }
      catch(error) {
        console.log(error)
      }
    });
    set_lock(props.env.lock)
    set_lock_user(props.env.lock_user)
    set_reason(props.env.lock_reason)
    set_change_frontend(props.env.change_frontend);
    set_change_backend(props.env.change_backend);
    set_branch_selected_frontend("workiz.com")
    set_branch_selected_backend("workiz.com")
    set_backend_branch(props.env.backend_branch)
    set_frontend_branch(props.env.frontend_branch)
    set_change_backend_open(props.env.change_backend);
    set_change_frontend_open(props.env.change_frontend);
    set_muted(props.env.users[0].envsOwners.muted);
    if(props.env.change_backend || props.env.change_frontend || props.env.create_frontend){
      set_lock(true)
    }
  },[,props.env.env_name])

  async function update_secret(){

    set_open_update_secrets(true)
    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "code": cookies.get("code"),
      "env_name" : props.env.env_name ,
    })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/update_env_backend_secrets/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
      }
      catch(error) {
        const event_id = captureException(error);
        console.log('error logged', { event_id });
      }
    });
  }

  async function removeItems(arr1, arr2) {
    for( var i=arr1.length - 1; i>=0; i--){
      for( var j=0; j<arr2.length; j++){
          if(arr1[i] && (arr1[i].id === arr2[j].id)){
            arr1.splice(i, 1);
         }
       }
   }
    return arr1;
  }

    const cookies = new Cookies();

    const users_select = {
      options: to_shared_users,
      getOptionLabel: (option) => option.slack_name,
  };

    function delete_env(){
      const inputs={"env_name":props.env.env_name,"login":cookies.get("login")}
      const index = props.prev_envs.findIndex((element)=>element.env_name==props.env.env_name)
      let array = props.prev_envs
      array.splice(index,1)
      props.set_prev_envs(array)
      const response = functions.delete_env(inputs, "delete_env.sh", cookies.get("login"), cookies.get("code"));
      props.setActiveIndex(-1)
      props.setIsOpen(false)
      handleClose();
    }

    const handle_unlock_dialog_close = () => {
      set_open_unlock_modal(false);
      set_reason("")
    };

    function lock_env(){

      set_lock(!lock)
      set_reason(reason)
      set_lock_user(cookies.get("name"))

      var options = {
        'method': 'POST',
        'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "code": cookies.get("code"),
        "env_name" : props.env.env_name ,
        "reason" : reason , 
        "block" : lock
      })
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/block_env/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
        }
        catch(error) {
          console.log(error)
        }
      });
      set_open_lock_modal(false)
      set_open_unlock_modal(false)
    }
  

    async function unshare_env(){
      var options = {
        'method': 'POST',
        'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
      "code": cookies.get("code"),
      "env_name" : props.env.env_name,
      "users" : unshare_users,
      "user_name" :  cookies.get("name")
      })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/unshare_env/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
        if (data.err){
          const event_id = captureException(data.err);
          console.log('error logged', { event_id }); 
        }
      }
      catch(error) {
        const event_id = captureException(error);
        console.log('error logged', { event_id });
      }
          
    }); 
    handleClose();
    const index = props.env.users.indexOf(unshare_users[0]);
    if (index > -1) { 
      props.env.users.splice(unshare_users[0], 1); 
    }
    set_to_shared_users([...to_shared_users,...unshare_users])
    await unshare_users.forEach(element => {
      set_env_users(env_users => env_users.filter(user => user.id !== element.id ))
    });
    }
    async function share_env(){
      var options = {
        'method': 'POST',
        'url': process.env.REACT_APP_INFRA_SERVICE_URL+"/github/share_env/" ,
        'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
      "code": cookies.get("code"),
      "env_name" : props.env.env_name,
      "users" : share_users,
      "user_name" :  cookies.get("name")
      })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/share_env/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
        if (data.err){
          const event_id = captureException(data.err);
          console.log('error logged', { event_id }); 
        }
        // set_share_users(null)
      }
      catch(error) {
        const event_id = captureException(error);
        console.log('error logged', { event_id });
      }
          
    }); 
    set_autocomplete_values([])
    set_env_users([...env_users,...share_users])
    await share_users.forEach(element => {
      set_to_shared_users(to_shared_users => to_shared_users.filter(user => user.id !== element.id ))
    });
    }

    useEffect( async ()=> {
      if(process.env.NODE_ENV=="staging"){
        console.log(props.env)
      }
      set_create_frontend(props.env.add_front=="null");
      set_update_frontend(props.env.update_front);
      set_update_backend(props.env.update_backend)
      set_env_users(props.env.users)
      set_env_users(users => users.filter(user => user.github_name !== cookies.get("login") ))
      let shared_users = await removeItems(JSON.parse(JSON.stringify(props.users)) ,JSON.parse(JSON.stringify(props.env.users)))
      set_to_shared_users(shared_users);
    },[props.env.env_name])

    async function pull_frontend(env_name,frontend_branch){
        set_lock(true)
        props.env.update_front=true
        const inputs={"env_name":env_name,"login":cookies.get("login"),"branch":frontend_branch}
        const response = await functions.update_env(inputs, "update_front.sh", cookies.get("login"), cookies.get("code"));
    }

    async function add_front(env_name,frontend_branch){
      set_lock(true)
      if(props.env.frontend_branch!="null"){
        return pull_frontend(env_name,frontend_branch);
      }
       
      set_create_frontend(true);
      props.env.add_front=true
      const inputs={"env_name":env_name,"frontend_branch":frontend_branch,"login":cookies.get("login")}
      const response = await functions.add_front(inputs, "add_front.sh", cookies.get("login"), cookies.get("code"));
  }

    async function pull_backend(env_name,backend_branch){
      set_lock(true)
      props.env.update_backend=true
      const inputs={"env_name":env_name,"login":cookies.get("login"),"branch":backend_branch}
      const response = await functions.update_env(inputs, "update_backend.sh", cookies.get("login"), cookies.get("code"));
    }

    function get_delete_time(env){
      var dates=[new Date(env.created_at||now()),new Date(env.frontend_last_update||now()),new Date(env.backend_last_update||now())]
      var maxDate=new Date(Math.max.apply(null,dates));
      const res=Moment(maxDate).add(7,"days");
      return Moment(res).format('LL')
    }

    async function unshare_user(user){
      set_unshare_users([user]);
      set_open_unshare_modal(true)

    }

    async function mute_env(){
      set_muted(!muted)
      var options = {
        'method': 'POST',
        'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "code": cookies.get("code"),
        "env_name" : props.env.env_name ,
        "muted" : !muted ,
        "user" : cookies.get("login")
      })
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/mute_env/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
        }
        catch(error) {
          console.log(error)
        }
      });
    }

    return (
      <div style={{"width": "71%" , "height": "-webkit-fill-available" }}>
        <div className="col2" >
          <a className="env_name" href= {`https://${props.env.env_name}.tests.workiz.com`} target="_blank" >
            {props.env.env_name}
            <img src={linkIcon} style={{"mrgin-lefta": "0.5em"}}/>
          </a>
          <a className="block_icon">{lock && reason?.length ?(<Tooltip title="Env blocked. Click to unblock it." followCursor><LockIcon onClick={() =>set_open_unlock_modal(true)}/></Tooltip>): (<Tooltip title="Env unblocked. Click to lock it." followCursor><LockOpenIcon onClick={() =>set_open_lock_modal(true)}/></Tooltip>) } </a>
            { lock && reason?.length && <div className="updated"> Blocked by - {lock_user}. Reason - {reason}</div>}
          <a className="mute">{muted ?(<Tooltip title="Env muted. click to unmute it." followCursor><VolumeOffIcon onClick={() =>mute_env()}/></Tooltip>): (<Tooltip title="Env not muted. click to mute it." followCursor><VolumeUpIcon onClick={() =>mute_env()}/></Tooltip>)}</a>
            {props.env.created_at && <div className="updated">Created at {Moment(props.env.created_at).format('LLL')} </div> }
            {props.env.temp_env && <div className="updated"> This is a temp env, that is going to be deleted at - {get_delete_time(props.env)} </div> }
          <div className="env_branches">
            <div style={{ "display": "flex" , "width": "-webkit-fill-available"}}>
                {backend_branch=="null" ? (
                <div style={{"flex": "auto"}}>
                  This env use workiz.com frontend. <EditOutlinedIcon onClick={()=>set_change_frontend_open(!change_frontend_open)} style={{"cursor": "pointer"}}/>
                </div>
                ):(
                  <div style={{"flex": "auto"}}>
                  Backend branch: {backend_branch} <EditOutlinedIcon onClick={()=>set_change_backend_open(!change_backend_open)} style={{"cursor": "pointer"}}/>
                  <div className="updated">
                  Last update - {Moment(props.env.backend_last_update).format('LLL')}
                    </div>
                    <div className="updated" style={{"display": (change_backend_open ||change_backend) ? "block" : "none"}}>
                    <div  style={{"display": "flex"}}>
                <Autocomplete
                    {...props.back_default_props}
                    autoSelect
                    size="small"
                    noOptionsText="loading more options..."
                    defaultValue="workiz.com"
                    sx={{ "width": "20em" }}
                    onChange={(event, value) => set_branch_selected_backend(value)}
                    renderInput={(params) => (
                    <TextField {...params} />
                    )}
                />
                 <Button text="Change branch" 
                    style={{ "fontWeight": "600" , "margin-left" : "0.5em" , "background": "space" , "text-align-last": "center"}}
                    onClick={()=>{pull_backend(props.env.env_name,branch_selected_backend); set_change_backend(true);}} 
                    disabled={ lock || backend_branch==branch_selected_backend || !branch_selected_backend}
                    loader={change_backend}
                    className="update"
                    />
                </div>
                      
                    </div>
                </div>
                )}
            </div>
            <div style={{"padding-top": "25px" ,  "width": "-webkit-fill-available"}}>
                {props.env.frontend_branch=="null" ? (
                <div style={{"flex": "auto"}}>
                  This env use workiz.com frontend. <EditOutlinedIcon onClick={()=>set_change_frontend_open(!change_frontend_open)} style={{"cursor": "pointer"}}/>
                </div>
                ):(
                  <div style={{"flex": "auto"}}>
                  Frontend branch: {frontend_branch} <EditOutlinedIcon onClick={()=>set_change_frontend_open(!change_frontend_open)} style={{"cursor": "pointer"}}/>
                    <div className="updated">
                      Last update - {Moment(props.env.frontend_last_update).format('LLL')}
                    </div>
                    </div>
                    )}
                      <div className="updated" style={{"display": (change_frontend ||create_frontend || change_frontend_open) ? "flex" : "none" ,"flex": "auto"}}>
                          <Autocomplete
                              {...props.front_default_props}
                              autoSelect
                              size="small"
                              noOptionsText="loading more options..."
                              defaultValue="workiz.com"
                              sx={{ "width": "20em" }}
                              onChange={(event, value) => set_branch_selected_frontend(value)}
                              renderInput={(params) => (
                              <TextField {...params} />
                              )}
                          />
                          <Button text={ props.env.frontend_branch!="null" ? "Change branch": "Add front" }
                              style={{ "float": "right" ,"fontWeight": "600" , "margin-left" : "0.5em" , "background": "space" , "text-align-last": "center"}}
                              onClick={()=>add_front(props.env.env_name,branch_selected_frontend)} 
                              disabled={create_frontend || lock || frontend_branch==branch_selected_frontend || !branch_selected_frontend}
                              loader={create_frontend || change_frontend}
                              className="update"
                              />
                      </div>
                
                
            </div>
            
          </div>
          <div >
            <div className="updates_child" style={{"margin-top":"2em"}} >
          <Button text="Delete"  disabled={lock} startIcon={<img src={deleteIcon}/>} onClick={handleClickOpen} className="delete"/>
          </div>
          <div style={{"float": "right" , "margin-top" : "2em"}}>
            <Button text="update backend" onClick={()=>{pull_backend(props.env.env_name); set_update_backend(true)}} disabled={update_backend || lock} loader={update_backend} className="update" /> 
            {frontend_branch!="null" && 
              <Button text="update front" onClick={()=>{pull_frontend(props.env.env_name); set_update_frontend(true)}} disabled={update_frontend || lock} loader={update_frontend} className="update"/>
            }
            </div>
          </div>
        </div>
        <div className="col2" >
          <a className="updates_child">
          Share this env with 
          </a>
          <a className="updates_child" style={{"float": "right"}}>
            <Autocomplete
              key={share_users}
              multiple
              size="small"
              value={autocomplete_values}
              disableCloseOnSelect
              {...users_select}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.slack_name}
                </li>
              )}
              id="auto-select"
              style={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Add users" />
              )}
              noOptionsText="No more options..."
              onChange={(event, value) => {set_share_users(value); set_autocomplete_values(value)}}
            />
          </a>
          <p style={{"margin-top": "2em"}}>
            <Button text="Share" style={{"color": "#3E45EF" , "border": "1px solid #3E45EF" , "width": "72px" , "float": "right" ,"fontWeight": "600"}} onClick={share_env} disabled={!share_users}/>
          </p>
          <p>
            <div className="line" style={{"margin-top" : "6em" , "width": "auto"}} />
          </p>
          
          <div className="shared_users">
            Shared users
               <List>
              {env_users.map((user) =>
                <ListItem
                key={user.slack_name}
                  secondaryAction={
                    <IconButton edge="start" aria-label="delete">
                      <CloseIcon onClick={()=>unshare_user(user)}/>
                    </IconButton>
                  }
                >
                  <ListItemText
                    primary={user.slack_name}
                  />
                </ListItem>
              )}
            </List>
          </div>
          <Button text="unfollow" startIcon={<img src={deleteIcon}/>} onClick={() => unshare_user({"github_name":cookies.get("login")})} className="delete" style={{"margin-top": "0.5em"}}/>
        </div>
        <div className="col2" >
          <a className="updates_child">
            Updated consts
          </a>
          <Button text="Update" onClick={() => update_secret()} disabled={lock} className="update"
            buttons={[{"text":"OK" ,  "class":"modalCancel", "onClick" : ()=>handleClose() }] } 
          />
          <BackendSecrets env={props.env.env_name} secrets={secrets} />
        </div>
        {open && 
          <Modal open={open} onClose={handleClose} 
            title={"Confirm deleting"} 
            text={"Are you sure you want to delete this environment? This action cannot be undone"}
            buttons={[{"text":"Cancel" ,  "class":"modalCancel", "onClick" : ()=>handleClose() },
                      {"text":"Delete" ,  "class": "modalOK" , "onClick" : ()=>delete_env() } 
                    ]}
          />
        }
        {open_unshare_modal && 
          <Modal open={open_unshare_modal} onClose={handleClose} 
          title={"Confirm unsharing"} 
          text={`Are you sure you want to unshare ${unshare_users[0].slack_name || cookies.get("name")} from this environment? This action cannot be undone`}
          buttons={[{"text":"Cancel" ,  "class":"modalCancel" , "onClick" : ()=>handleClose() },
                    {"text":"Unshare" ,  "class": "modalOK", "onClick" : ()=>unshare_env() } 
                  ]}
        />
        }
      <Modal open={open_lock_modal} onClose={handleClose} 
          title={`Lock env `+props.env.env_name}
          text={"To lock env "+props.env.env_name+", please write the reason"}
          textField={true}
          textFieldLabel={"Write the reason"}
          textFieldSetText={set_reason}
          buttons={[
                    {"text":"Cancel" , "class":"modalCancel", "onClick" : ()=>handle_unlock_dialog_close() },
                    {"text":"Lock" ,  "class": "modalOK", "onClick" : ()=>lock_env() ,"disabled": !reason?.length}
                  ]}
        />

        <Modal open={open_unlock_modal} onClose={handleClose} 
          title={`Unlock env `+props.env.env_name}
          text={"To unlock env "+props.env.env_name+", please write the reason"}
          textField={true}
          textFieldLabel={"Write the reason"}
          textFieldSetText={set_reason}
          buttons={[
                    {"text":"Cancel" ,  "class":"modalCancel" , "onClick" : ()=>handle_unlock_dialog_close() },
                    {"text":"Unlock" ,  "class": "modalOK", "onClick" : ()=>lock_env() ,"disabled": !reason?.length }
                  ]}
        />

        <Modal open={open_update_secrets} onClose={() => {set_open_update_secrets(false)}} 
          title={`secret updated`}
          text={""}
        />

      </div>
    )
}